import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { api_url } from '../../../Constants/web_services';
import { useSelector } from 'react-redux';
import { selectUserData } from '../../../Redux/UserSlice';
import { useNavigate } from 'react-router-dom';


function CancelOrder({ order }) {
    const userData = useSelector(selectUserData);
    const [orderPaymenStatus, setorderPaymenStatus] = useState('');
    const navigate = useNavigate();
    useEffect(() => {
        if (order?.id) {
            // Define the API URL based on the ID parameter
            const fetchOrderDetail = async () => {
                const token = localStorage.getItem('token'); // Retrieve the token from local storage

                const orderDetailUrl = api_url + `/api/user-profile/order-detail/${order?.id}`;
                try {
                    const response = await fetch(orderDetailUrl, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}` // Include the token in the Authorization header
                        }
                    });

                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }

                    const orderStatus = await response.json();
                    setorderPaymenStatus(orderStatus?.data?.order_payment?.payment_redirect_status);
                } catch (error) {
                    console.error("Error fetching order data:", error);
                }
            };

            fetchOrderDetail();
        }
    }, [order?.id]);


    const handleCancelOrder = async () => {
        // Show confirmation dialog
        const confirmationResult = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to cancel this order?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, cancel it!",
            cancelButtonText: "No, keep it"
        });

        // Check if the user confirmed
        if (confirmationResult.isConfirmed) {
            try {
                const token = localStorage.getItem('token'); // Retrieve the token from local storage

                const response = await fetch(api_url + `/api/refund/${order?.id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}` // Include the token in the Authorization header
                    }
                });

                if (response.ok) {
                    Swal.fire({
                        title: "Succeed!",
                        text: "Order canceled successfully.",
                        icon: "success",
                        confirmButtonColor: "#3085d6",
                    });

                    // Reload the page after 3 seconds
                    setTimeout(() => {
                        navigate(`/user-profile/${userData?.id}/orders`);
                    }, 3000);

                } else {
                    const data = await response.json();
                    console.log(data);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to cancel order. Please try again later.",
                        icon: "error",
                        confirmButtonColor: "#3085d6",
                    });
                }
            } catch (error) {
                console.error('Error cancelling order:', error.message);
                Swal.fire({
                    title: "Error!",
                    text: "Failed to cancel order. Please try again later.",
                    icon: "error",
                    confirmButtonColor: "#3085d6",
                });
            }
        }
    };



    return (
        <>
            {orderPaymenStatus === "refund succeeded" ? (

                <>
                    <dt className="m-0"><u>Order refunded</u></dt>

                    <p className='text-danger text-capitalize ml-4 mb-1'>refund succeed</p>
                    <p className='text-danger text-capitalize ml-4'>will we receive in 14 days ,
                        & 5% of your amount will be deducted according to company policy</p>
                </>

            ) : (
                <>
                    <dt className="m-0"><u>Cancel order</u></dt>
                    <details>
                        <summary className="text-danger fw-600">Note :</summary>
                        <div className=''>
                            <p className='text-uppercase text-center text-danger fw-800 font-size-12 m-1'>- 10% is deducted after three days of order payment</p>
                            <p className='text-uppercase text-center text-danger fw-800 font-size-12'>- If you cancel this order, payment will be back in 14 working days in your account</p>
                            <button
                                className="theme-danger btn-sm me-1 col-sm-2 ml-3 border-0"
                                style={{ width: "50px", height: "30px", }}
                                title="Cancel Order"
                                onClick={handleCancelOrder}
                            >
                                <i className="fas fa fa-xmark text-white" style={{ fontSize: "10px" }} />
                                <i className="fas fa fa-cart-shopping text-white" style={{ fontSize: "16px" }} />
                            </button>
                        </div>
                    </details>
                </>
            )}

        </>
    );
}

export default CancelOrder;
